let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1SzkV")).then(() => parcelRequire('59s8T'));